import React, { ReactNode } from 'react';
import SideBar from '../sidebar/Sidebar';
import styles from './layout.module.css';
import { useAppSelector } from '../../redux/hooks';

interface LayoutProps {
    children: ReactNode;
    isExpanded: boolean;
    onToggle: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, isExpanded, onToggle }) => {
    // Get current user from Redux store
    const { user } = useAppSelector((state) => state.currentUser);

    // Format user's full name
    const userName = user ? `${user.firstName} ${user.lastName}` : undefined;

    return (
        <div className={styles['appLayout']}>
            {/* Sidebar */}
            <SideBar
                isExpanded={isExpanded}
                onToggle={onToggle}
                userName={userName}
            />

            {/* Main Content Area */}
            <main className={`${styles['mainContent']} ${isExpanded ? styles['sidebarExpanded'] : styles['sidebarCollapsed']}`}>
                {children}
            </main>
        </div>
    );
};

export default Layout;